var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(-5742.814 305.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5556",
    "data-name": "Path 5556",
    d: "M5752.176-305.7c.446.068.9.107,1.335.209a8.461,8.461,0,0,1,5.966,4.576,8.017,8.017,0,0,1-.675,8.54c-.069.1-.153.2-.23.294l-.245.31c.051.053.1.107.153.159l4.929,4.952a1.1,1.1,0,0,1,.233,1.435,1.159,1.159,0,0,1-1.7.269,3.09,3.09,0,0,1-.229-.213q-2.465-2.475-4.929-4.952a1.023,1.023,0,0,1-.1-.134c-.562.286-1.062.586-1.6.8a8.731,8.731,0,0,1-7.169-.093,8.3,8.3,0,0,1-4.792-5.531,7.85,7.85,0,0,1,.928-6.435,8.631,8.631,0,0,1,5.743-4.005c.4-.089.821-.125,1.232-.186Zm-.575,2.215a6.39,6.39,0,0,0-6.478,6.265,6.386,6.386,0,0,0,6.477,6.265,6.389,6.389,0,0,0,6.487-6.274A6.387,6.387,0,0,0,5751.6-303.48Z",
    fill: "#2f6bc1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRequestIcon);
export default __webpack_public_path__ + "static/media/search-request-icon.3d1bf445ea341d04522eb6c5bd42888a.svg";
export { ForwardRef as ReactComponent };